export enum AppRoutes {
	AUTH = 'auth',
    DATASET = 'dataset',
    DATASETEDIT = 'edit',
    DATASETADD = 'add',
    DATASETVIEW = 'view',
    OTHER = 'other'
}